<template>
  <div>
    <table-filter v-model="filter" :columns="columns"/>
    <div class="row justify-between">
      <div></div>
      <q-table-columns
        color="secondary"
        class="q-mr-sm"
        style="width: 100px;"
        v-model="visibleColumns"
        :columns="columns"
      />
    </div>
    <h-table
      :data="data"
      row-key="label"
      :columns="columns"
      :visible-columns="visibleColumns"
      :filter="filter"
      :pagination.sync="serverPagination"
      :rows-per-page-options="perPageOptions"
      :loading="loading"
      ref="table"
      @request="fetchData"
    >
      <q-td 
        slot="body-cell-edit" 
        class="text-right" 
        slot-scope="props"
      >
        <q-btn
          @click="viewUser(props.value)"
          icon="visibility"
          color="tertiary"
          class="hover-positive" flat
          round
        />
        <q-btn
          @click="$router.push('/users/' + props.value)"
          icon="edit"
          color="tertiary"
          class="hover-primary"
          flat
          round
        />
      </q-td>
    </h-table>
    <UserPreview v-model="viewUserModalOpened" :user="user"/>
  </div>
</template>

<script>
  import UserPreview from '@/UserPreview';
  import tableHelpers from '@/HTable/helpers';
  import columns from './mixins/columns';
  import api from 'mixins/api';
  import {
    HTable,
    HTh
  } from '@';
  import TableFilter from '@/TableFilter';
  import {
    QTable,
    QTableColumns,
    QTr,
    QTh,
    QTd,
    QField,
    QInput,
    QCheckbox,
    QSelect,
    QSlider,
    QBtn,
    QIcon,
    QTooltip,
    QPopover,
    QModal
  } from 'quasar';

  export default {
    name: 'UsersList',
    components: {
      QTable,
      QTableColumns,
      QTr,
      QTh,
      QTd,
      QField,
      QInput,
      QCheckbox,
      QSelect,
      QSlider,
      QBtn,
      QIcon,
      QTooltip,
      QPopover,
      QModal,
      HTable,
      HTh,
      TableFilter,
      UserPreview
    },
    mixins: [
      columns,
      api,
      tableHelpers
    ],
    data () {
      return {
        visibleColumns: this.getVisibleColumns() || ['first_name', 'last_name', 'email', 'role', 'edit'],
        newUser: false,
        viewUserModalOpened: false,
        user: {}
      };
    },
    mounted () {
      this.fetchData({
        pagination: this.serverPagination,
        filter: this.filter
      });
    },
    methods: {
      fetchData ({pagination, filter}) {
        this.query = this.getQuery(pagination, filter);
        this.loading = true;
        this.$http.get(`/api/v1.0/users/${this.query}`).then((response) => {
          if (this.verifyResponse(response)) {
            this.updatePagination(pagination, response.data.total);
            this.updateData(response.data.users);
            this.$store.commit('usersList/setData', response.data);
          }
          this.loading = false;
        }).catch(error => {
          console.error(error);
          this.loading = false;
        });
      },
      viewUser (id) {
        this.viewUserModalOpened = true;
        this.user = this.data.find(row => row.id === id);
      }
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/UsersList/UsersList.vue